

































import Vue from 'vue';
import GetLink from '@/dialog/GetLink.vue';
import DeleteAssignment from '@/dialog/DeleteAssignment.vue';
import {
  getAssignment, getSubmissionList, Assignment, Submission, getDownloadSubmissionAsZipURL,
  getSubmitLink,
} from '@/repository/assignment';

export default Vue.extend({
  components: {
    GetLink,
    DeleteAssignment,
  },
  props: [
    'id',
  ],
  data: () => ({
    assignment: {} as Assignment,
    submissionList: new Array<Submission>(),
    downloadLink: '',
    submitLink: '',
    isLoading: true,
  }),
  watch: {
    id: {
      immediate: true,
      handler() {
        this.updateAss();
      },
    },
  },
  methods: {
    updateAss() {
      console.debug(`Fetch assignment: ${this.id}`);
      this.isLoading = true;
      getAssignment(this.id).then((result) => {
        this.assignment = result;
        this.downloadLink = getDownloadSubmissionAsZipURL(this.assignment);
        this.submitLink = getSubmitLink(this.assignment);
        return getSubmissionList(this.assignment);
      }).then((result) => {
        this.submissionList = result;
        this.isLoading = false;
      }).catch((err) => {
        this.isLoading = false;
        if (err.message === '404') {
          this.$router.push('/404');
          return;
        }
        console.error('Fetch error: ', err);
      });
    },
  },
});
